// ----------------------------------------------------------------------

export const JWT_STORAGE_KEY = 'POLYFILLER_KEY';
export const USER_ID_STORAGE_KEY = 'POLYFILLER_ID';
export const USER_ACCESS_PERMISSIONS = 'POLYFILLERS';
export const COMPANY_ID = 'POLIFILLER_PARENT_ID';
export const USERE_DETAILS = 'POLYFILLER_DETAILS';
export const USER_MOBILE_NUMBER = 'POLYFILLER_MOBILE_NUMBER';
